import { ContextTypes } from './environment.types';

declare const initDatas: any;

export const environment = {
  PRODUCTION: true,
  CONTEXT: ContextTypes.WEB,
  ASSETS_SERVER: '',
  BRAND:initDatas.brand,
  LOGO:{
    SPLASH:'/assets/img/logos/logo-'+initDatas.brand+'-print.svg',
    LABEL:'/assets/img/logos/logo-'+initDatas.brand+'.svg',
    PDF_LOGO:'/assets/img/logos/logo-pdf-'+initDatas.brand+'.svg',
    PDF_PRINT_LOGO:'/assets/img/logos/logo-pdf-'+initDatas.brand+'-print.svg'
  },
  PDF_URL : initDatas.brand == 'elba' ? 'www.elbaprint.com' : 'www.myoxfordprint.com',
  API_BASE: '/api/',
  API_SERVICES: {
    user:"user",
    project:"project",
    media:"media"
  },
  PROJECT_FOLDER:'/upload/user-projects/',
  USER_FONTS_FOLDER:'/upload/user-fonts/',
  USER_IMAGES_FOLDER:'/upload/user-images/',
  USER_CSV_FOLDER:'/upload/user-csvs/',
  API_TOKEN: '943af478d3ff3d4d760020c11af102b79c440513',
  VERSION: '1.1',
  API_VERSION: '1.1',
};
